export default "__VITE_ASSET__BDV4AWCz__"